import React from "react";
import { useHistory } from "react-router-dom";
import { Button, CircularProgress } from "@material-ui/core";
import { Search, SlidersHorizontal } from "lucide-react";
import styles from "./Header.module.scss";
import { useAuth } from "../../../../services/auth";
import { useExportInventoryPdf } from "../../../../utils/react-query/queryInventory/queries";

interface HeaderProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  onFilterToggle: () => void;
  isFilterOpen: boolean;
}

export function Header({
  searchQuery,
  onSearchChange,
  onFilterToggle,
  isFilterOpen,
}: HeaderProps) {
  const history = useHistory();
  const { isSupplier } = useAuth();
  const { mutate: exportPdf, isLoading: isExporting } = useExportInventoryPdf();

  return (
    <header className={styles.header}>
      <div className={styles.headerContent}>
        <div className={styles.leftSide}>
          <h1 className={styles.title}>Sistema de Inventarios</h1>

          <div className={styles.searchWrapper}>
            <Search className={styles.searchIcon} />
            <input
              type="text"
              placeholder="Buscar categorías, referencias, líneas..."
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
              className={styles.searchInput}
            />
          </div>

          <button
            onClick={onFilterToggle}
            className={`${styles.filterButton} ${
              isFilterOpen ? styles.active : ""
            }`}
          >
            <SlidersHorizontal className={styles.icon} />
            <span className={styles.buttonText}>Filtros</span>
          </button>
        </div>

        <div className={styles.rightSide}>
          {isSupplier && (
            <>
              <Button
                variant="outlined"
                color="default"
                onClick={() => exportPdf()}
                disabled={isExporting}
              >
                {isExporting ? (
                  <CircularProgress size={18} style={{ marginRight: 8 }} />
                ) : null}
                Exportar PDF
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={() => history.push("/proveedor/producto/nuevo")}
              >
                Nuevo Producto
              </Button>
            </>
          )}
        </div>
      </div>

      <div className={styles.mobileSearch}>
        <Search className={styles.searchIconMobile} />
        <input
          type="text"
          placeholder="Buscar referencias..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className={styles.searchInputMobile}
        />
      </div>
    </header>
  );
}
